// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2RYc3","text":"SelectPayment_text__2sG3h","title":"SelectPayment_title__2Q7TS","btn":"SelectPayment_btn__2BSaD"};